"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currencyFormatter = currencyFormatter;
exports.numberFormatter = numberFormatter;

// Formats argument with dollar sign, two decimals and commas
function currencyFormatter(num) {
  var minimumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (num !== 0 && !num) return ''; // for numbers !0 returns false otherwise true

  num = num.toString();

  if (num.indexOf('$') !== -1) {
    num = num.split('$')[1];
  }

  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: minimumFractionDigits
  });
  return formatter.format(num);
} // Formats argument with dollar sign, two decimals and commas


function numberFormatter(num) {
  var minimumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (!num || num !== Number(num)) return ''; // accept only numbers

  num = num.toString();
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: minimumFractionDigits
  });
  return formatter.format(num);
}